/* Constants */
const CONTAINER = ".site-header-container";
const SCROLLED = "scrolled";

/* Functions */
const init = () => {
  const menu = jQuery(CONTAINER);

  if (window.scrollY > 0) menu.addClass(SCROLLED);

  jQuery(window).on("scroll", () => {
    const isScrolled = window.scrollY > 0;
    const wasScrolled = menu.hasClass(SCROLLED);

    if (wasScrolled && !isScrolled) menu.removeClass(SCROLLED);
    else if (!wasScrolled && isScrolled) menu.addClass(SCROLLED);
  });
};

export default init;
